import { Eye, Download } from "lucide-react";
import { useFilePreview } from "@/context/FilePreviewContext";

/** Formats ouvrables dans la visionneuse intégrée (PDF + images). */
export const isPreviewable = (filename, contentType) =>
  /^(application\/pdf|image\/(jpeg|png|webp))$/i.test(contentType || "") || /\.(pdf|jpe?g|png|webp)$/i.test(filename || "");

const BTN = { width: 30, height: 30, borderRadius: 6, border: "0.5px solid #3a3a40", background: "#1c1c20" };

/**
 * Duo « Voir » + « Télécharger » commun à toutes les pièces jointes (spec iter125).
 * `url` = route API de téléchargement (token joint automatiquement).
 */
export default function AttachmentActions({ url, filename, contentType, downloadColor = "#e6e6ea", testId = "attach", size = 30, children, gallery = null, galleryIndex = 0, plan = false }) {
  const { openAuthenticatedUrl, buildDownloadHandler } = useFilePreview();
  const ok = isPreviewable(filename, contentType);
  const btn = { ...BTN, width: size, height: size };
  return (
    <span className="inline-flex items-center shrink-0" style={{ gap: 6 }} onClick={(e) => e.stopPropagation()}>
      <button type="button" disabled={!ok} aria-disabled={!ok}
        onClick={() => ok && openAuthenticatedUrl(url, { filename, contentType, gallery, index: galleryIndex, plan })}
        className="inline-flex items-center justify-center transition-colors hover:bg-white/5"
        style={{ ...btn, color: ok ? "#e6e6ea" : "#3a3a40", cursor: ok ? "pointer" : "not-allowed" }}
        title={ok ? "Voir" : "Aperçu indisponible"} data-testid={`${testId}-view`}><Eye size={size < 26 ? 12 : 14} /></button>
      <button type="button" onClick={buildDownloadHandler(url, { filename })}
        className="inline-flex items-center justify-center transition-colors hover:bg-white/5"
        style={{ ...btn, color: downloadColor }} title="Télécharger" data-testid={`${testId}-download`}><Download size={size < 26 ? 11 : 12} /></button>
      {children}
    </span>
  );
}
